import { FormControl, InputLabel, InputLabelProps, MenuItem, Select, SelectProps } from '@material-ui/core';
import { selectStores } from 'app/main/apps/stores/ducks/stores.selector';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

interface SelectStoresProps {
  className?: string;
  label?: SelectProps['label'];
  required?: SelectProps['required'];
  variant?: SelectProps['variant'];
  onSelect: (value?: string) => void;
  value?: string;
  defaultLabel?: string;
  inputProps?: SelectProps['inputProps'];
  labelProps?: InputLabelProps;
  size?: 'small' | 'medium';
  isDisabled?: boolean;
}

function SelectStores({
  className,
  label,
  required,
  variant,
  onSelect,
  value,
  defaultLabel,
  inputProps,
  labelProps,
  size = 'medium',
  isDisabled,
}: SelectStoresProps) {
  const stores = useSelector(selectStores);

  return (
    <FormControl variant={variant} className={className}>
      <InputLabel {...labelProps} id="category-selector" className={clsx(size === 'small' ? 'h-40' : undefined)}>
        {label}
      </InputLabel>
      <Select
        className={clsx(size === 'small' ? 'h-40' : undefined)}
        label={label}
        value={value || defaultLabel || ''}
        inputProps={inputProps}
        onChange={event => onSelect(event.target.value === defaultLabel ? undefined : (event.target.value as string))}
        required={required}
        labelId="category-selector"
        disabled={isDisabled}
      >
        {defaultLabel && (
          <MenuItem key={0} value={defaultLabel}>
            {defaultLabel}
          </MenuItem>
        )}
        {stores.map(store => (
          <MenuItem key={store.id} value={store.id}>
            {store.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default SelectStores;
